/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { PinType } from 'src/app/_model/pin-type';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class PinTypesDaoService implements Resetable {
  public abstract savePinTypes(pins: PinType[]): Promise<void>;
  public abstract getPinTypes(): Promise<PinType[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
